import React from 'react'
import { images } from '../../assets'

import { useNavigate } from 'react-router-dom'
const ApplyPcContent = () => {
  const navi = useNavigate()
  return (
    <div className="application_info">
      <div className="application_info_logo">
        <img src={images.logoBlack} alt="logo_brg" />
      </div>
      <div className="application_info_text">
        <div className="application_info_tit">
          <p>사장님~</p>
          <p>댓글 관리에서 </p>
          <p>해방시켜드립니다!!!</p>
        </div>
        <div className="application_info_hashtag">
          <p># 쉽게</p>
          <p># 마음편하게</p>
          <p># 효과적으로</p>
          <br />
          <p># 매장리뷰 </p>
          <p># 대신관리</p>
        </div>
      </div>
      {/*<div className="application_info_link">*/}
      {/*  <button onClick={() => navi('/')} className="btn_default">*/}
      {/*    스폰지R 더 알아보기*/}
      {/*  </button>*/}
      {/*  <a href="https://www.spge.kr" target="_blank" className="btn_default btn_spge">*/}
      {/*    스폰지도 같이 알아보기*/}
      {/*  </a>*/}
      {/*</div>*/}
      <div className="spge">
        <p>“지역소상공인”과 함께하는 &#40;주&#41;에스피지이 www.spge.kr</p>
        <p className="bold">고객센터 050-7964-1000</p>
      </div>
    </div>
  )
}

export { ApplyPcContent }
